//*Libraries imports
import { X } from "lucide-react";

interface PaymentErrorModalProps {
  isOpen: boolean;
  onClose: () => void;
  onRetry?: () => void;
}

export function PaymentErrorModal({
  isOpen,
  onClose,
  onRetry,
}: PaymentErrorModalProps) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/35 backdrop-blur-sm p-4">
      <div className="w-full max-w-xs bg-white rounded-2xl p-6 flex flex-col items-center justify-start gap-4 shadow-xl animate-in fade-in zoom-in duration-200">
        {/* Error Icon */}
        <div className="size-24 rounded-full bg-[#F04438]/15 flex items-center justify-center">
          <div className="size-16 rounded-full bg-[#F04438] flex items-center justify-center">
            <X size={40} className="text-white" strokeWidth={3} />
          </div>
        </div>

        <div className="flex flex-col items-center gap-1">
          <h3 className="text-clarotextos-01 text-lg font-bold">ERRO!</h3>

          <p className="text-clarotextos-02 text-sm font-normal text-center">
            Pagamento não aprovado, tente novamente.
          </p>
        </div>

        <button
          onClick={onRetry ?? onClose}
          className="w-full h-11 bg-claroprimaria-01 hover:bg-[#1565af] active:bg-[#125391] text-white rounded-xl font-semibold text-base transition-colors flex items-center justify-center"
        >
          Fechar
        </button>
      </div>
    </div>
  );
}
